import styled from 'styled-components';

export const MainContainer = styled.div`
    .table,
    table * {
        border: none;
        box-sizing: border-box;
    }

    .table {
        border: 3px solid ${props => props.theme.accountCashbackTableBorderColor};
        border-collapse: separate;
        border-spacing: 0;
        margin: 0;

        thead {
            background: ${props => props.theme.accountCashbackTableTheadBackgroundColor};
        }

        th {
            padding: 15px 20px;
            text-transform: uppercase;
            vertical-align: middle;
            color: ${props => props.theme.white};
            border: 1px solid ${props => props.theme.black};
        }

        tbody td {
            padding: 15px 20px;
            border-bottom: 2px ${props => props.theme.accountCashbackTableBorderColor} solid;
            vertical-align: middle;
        }

        ul.tiret li:before {
            content: ' - ';
            display: inline-block;
        }

        td.opacite {
            font-weight: bold;
        }
    }

    table {
        ul {
            list-style: none;
            margin: 0;
            padding: 0;
        }
    }

    .opacite {
        color: ${props => props.theme.accountCashbackTableGainColor};
        background-color: rgba(99, 184, 164, 0.1);
    }

    .empty {
        text-align: center;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/account/AccountPageStyle.js